var map = {
	"./ai.png": 42028,
	"./excel.png": 20553,
	"./mp3.png": 89118,
	"./no.png": 90187,
	"./pdf.png": 33570,
	"./ppt.png": 31420,
	"./psd.png": 62793,
	"./txt.png": 28832,
	"./video.png": 4753,
	"./word.png": 40206,
	"./zip.png": 69877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98321;